/** Préférences d'interface (mode clair/sombre). */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type ColorMode = 'light' | 'dark';

interface UiState {
  colorMode: ColorMode;
}

const themeGuard = typeof window !== 'undefined' ? localStorage.getItem('nexacraft:colorMode') : null;

const initialState: UiState = {
  colorMode: themeGuard === 'dark' || themeGuard === 'light' ? themeGuard : 'light',
};

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleColorMode(state) {
      state.colorMode = state.colorMode === 'light' ? 'dark' : 'light';
      localStorage.setItem('nexacraft:colorMode', state.colorMode);
    },
    setColorMode(state, action: PayloadAction<ColorMode>) {
      state.colorMode = action.payload;
      localStorage.setItem('nexacraft:colorMode', action.payload);
    },
  },
});

export const { toggleColorMode, setColorMode } = uiSlice.actions;
